module.exports = __webpack_public_path__ + "img/four.971bc2b3.png";